import Typed from 'react-typed';
import './styles.css'


export default function PresentationName () {
    return (
        <div className='presentation-name'>
            <p className='small-letter'><span id='hello'>¡Hola!</span>, mi nombre es</p>
            <h1 className="name">Angel Gabriel Vega</h1>
            <p className='small-letter'>
                Soy
                <span> </span>
                <span className='typing'> 
                    <Typed
                        
                        strings= {['Front-End Developer', 'Back-End Developer', 'Full Stack Developer']}
                        typeSpeed= {70}
                        loop
                        
                        />
                </span>
            </p>
        </div>
    )
}